import type { AgentMessage } from "../ai-chat-message-utils";
import { extractTextFromMessageContent } from "../ai-chat-message-utils";

interface UserMessageProps {
  message: Extract<AgentMessage, { role: "user" }>;
  latestExchangeAnchorRef?: React.Ref<HTMLDivElement>;
}

export const UserMessage = ({ message, latestExchangeAnchorRef }: UserMessageProps) => (
  <div className="tcw-message tcw-message--user" ref={latestExchangeAnchorRef}>
    <p className="tcw-bubble tcw-bubble--user">
      {extractTextFromMessageContent(message.content)}
    </p>
  </div>
);
